import { getConfiguration } from "./configuration";

function getMinMaxOdd(odds) {
    let minOdd = odds?.[0];
    let maxOdd = odds?.[0];
    odds?.forEach(odd => {
        if (odd.rawValue > maxOdd.rawValue) maxOdd = odd;
        if (odd.rawValue < minOdd.rawValue) minOdd = odd;
    });
    return [minOdd, maxOdd];
}

//  Restituisce la linea di default da pre-selezionare in un selector di handicap priorità:
//   mainLine 
//   BALANCED_MULTILINE_BET se conf.bmb è attivo
//   prima linea con almeno una quota aperta

export function getDefaultLine(bets) {
    const conf = getConfiguration();

    for (let i = 0; i < bets.length; i++) {
        const currentBet = bets[i];

        if (currentBet?.mainLine && String(currentBet.mainLine) == String(currentBet.handicap)) {
            return currentBet;
        }
    }

    if (conf?.bmb) {
        let bet = null;
        let minRawValueDiff = Number.MAX_VALUE;
        for (let i = 0; i < bets.length; i++) {
            const currentBet = bets[i];
            if (currentBet?.odds?.length >= 2) {
                const [minOdd, maxOdd] = getMinMaxOdd(currentBet.odds);
                if (minOdd && maxOdd) {
                    const rawValueDiff = Math.abs(minOdd.rawValue - maxOdd.rawValue);
                    if (rawValueDiff < minRawValueDiff) {
                        minRawValueDiff = rawValueDiff;
                        bet = currentBet;
                    }
                }
            }
        }
        if (bet) return bet;
    }

    const firstOpen = bets.find(b => b.odds?.some(o => o.value != null));
    if (firstOpen) return firstOpen;

    return bets[0];
}